import * as React from 'react';
import { ReactComponent as CheckboxSelected } from 'assets/checkbox-selected.svg';
import { ReactComponent as CheckboxEmpty } from 'assets/checkbox-empty.svg';
import { SvgIcon } from '@material-ui/core';

export const icon = <SvgIcon component={CheckboxEmpty} />;

export const checkedIcon = <SvgIcon component={CheckboxSelected} />;
